import React, { Component } from "react";
import techforceLogo from "../images/tech-logo.png";
// import techforceLogo from "../images/tech-logo-icon.png";
import createSkill from "../images/sidebar-new/plus-icon.png";
import mySkills from "../images/sidebar-new/my-skills.png";
import superSkills from "../images/sidebar-new/skill-store.png";
import myKnowledgeIcon from "../images/sidebar-new/super-knowledge.png";
import mytaskIcon from "../images/sidebar-new/task-approval.png";
import dropIcon from "../images/sidebar-new/drop-icon.png";
import getSuperImg from "../images/sidebar-new/get-super-img.png";
import settingIcon from "../images/sidebar-new/settings.png";
import myTask from "../images/sidebar-new/my-task.png";
import platformIcon from "../images/sidebar-new/platform-icon.png";
import analyticsIcon from "../images/sidebar-new/analytics.png";
import createTemplateIcon from "../images/sidebar-new/create-template.png";
import scheduleIcon from "../images/sidebar-new/schedule.png";
import StepTwo from "../containers/dashboard/ConnectDevice/components/StepTwo";
import StepThree from "../containers/dashboard/ConnectDevice/components/StepThree";
import StepFour from "../containers/dashboard/ConnectDevice/components/StepFour";
import StepFive from "../containers/dashboard/ConnectDevice/components/StepFive";
import StepOne from "../containers/dashboard/ConnectDevice/components/StepOne";
import close from "../images/close.png";
import ConnectDevice from "../containers/dashboard/ConnectDevice";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "redux";
import { changeActiveTab } from "../redux/actions/skill";
import {
  getOrganizations,
  setCurrentOrganization,
  getCurrentUser,
} from "../redux/actions/organizationAction";
import {
  downloadExe,
  getDeviceInfoApi,
} from "../containers/dashboard/ConnectDevice/util";
import { setGroupPlan } from "../redux/actions/user";
import { getKeycloackToken } from "../redux/actions/auth";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import { changeMode } from "../redux/actions/appActions";
import editIcon from "../images/edit-icon.png";
import { Satellite } from "@material-ui/icons";
import webIcon from "../images/icons/ios-globe.svg";
import windowsIcon from "../images/icons/logo-windows.svg";
import extLayer from "../images/icons/ext-path.svg";
import extIcon from "../images/icons/ext-icon.svg";
import { getCookie, setCookie } from "../common/cookie_helper";
import $ from "jquery";

class SideBar extends Component {
  constructor() {
    super();
    this.state = {
      connectDevice: false,
      stepOne: false,
      stepTwo: false,
      stepThree: false,
      stepFour: false,
      stepFive: false,
      superWindowDeviceName: "",
      showUpdateModal: false,
      blobUrl: "",
      current_version: "",
      minMode: false,
      isLoading: true,
    };
  }

  async componentDidMount() {
    $(".task-list").removeClass("active");
    $(".fixed-bar").removeClass("active");
    $(".inner-left-sidebar").removeClass("active");
    let _orgDetail;
    await this.props.getCurrentUser(this.props.userReducer?.user?.email);
    var results = await this.props.getOrganizations();
    let _storedId = getCookie("org_id");
    let _defaultId;
    _defaultId = results?.data?.data?.filter(
      (i) => i.id == this.props.userReducer?.user?.organizationId[0]
    );
    if (_storedId) {
      _orgDetail = results?.data?.data?.filter((i) => i.id == _storedId);

      if (_orgDetail?.length > 0) {
        await this.props.setCurrentOrganization(_orgDetail[0]);
      } else {
        await this.props.setCurrentOrganization(_defaultId[0]);
        // await window.cookieStore.set({
        //   name: "org_id",
        //   value: _defaultId[0]?.id,
        //   sameSite: window.location.hostname.startsWith("localhost")
        //     ? "strict"
        //     : "none",
        //   domain: window.location.hostname.startsWith("localhost")
        //     ? undefined
        //     : "supervity.ai",
        // });
        //document.cookie = `org_id=${_defaultId[0]?.id};`;
        setCookie("org_id", _defaultId[0]?.id);
      }
      this.setState({ isLoading: false });
    } else {
      this.props.setCurrentOrganization(_defaultId[0]);
      // await window.cookieStore.set({
      //   name: "org_id",
      //   value: _defaultId[0]?.id,
      //   sameSite: window.location.hostname.startsWith("localhost")
      //     ? "strict"
      //     : "none",
      //   domain: window.location.hostname.startsWith("localhost")
      //     ? undefined
      //     : "supervity.ai",
      // });
      //document.cookie = `org_id=${_defaultId[0]?.id};`;
      setCookie("org_id", _defaultId[0]?.id);
      this.setState({ isLoading: false });
    }
    this.checkUpdates();
  }

  checkUpdates = async () => {
    var sessionRes = await getDeviceInfoApi();
    var newDownload = await downloadExe();

    if (
      sessionRes &&
      sessionRes?.data &&
      sessionRes?.data?.uniqueDevices?.length
    ) {
      let deviceList = sessionRes?.data?.uniqueDevices[0];
      let _versionNumber = deviceList?.meta_data?.extensionVersion;

      let blobNameExtract = newDownload.data.blobName.split("-");
      let _manipulate =
        blobNameExtract[blobNameExtract.length - 1].split(".exe");
      let blobVersionExtract = _manipulate[0];
      if (_versionNumber !== blobVersionExtract) {
        this.setState({
          showUpdateModal: true,
          blobUrl: newDownload.data.url,
          current_version: blobVersionExtract,
        });
      }
    }
  };

  connectDeviceToggle(status) {
    this.setState({
      connectDevice: status,
    });
  }

  stepOneToggle(status) {
    this.setState({
      stepOne: status,
    });
  }
  stepTwoToggle(status) {
    this.setState({
      stepTwo: status,
      // stepOne: false,
    });
  }
  stepThreeToggle(status) {
    this.setState({
      stepThree: status,
      stepTwo: false,
    });
  }
  stepFourToggle(status) {
    this.setState({
      stepFour: status,
      stepThree: false,
    });
  }
  stepFiveToggle(status) {
    this.setState({
      stepFive: status,
      stepFour: false,
    });
  }
  superWindowDeviceNameToggle(deviceName) {
    this.setState({
      superWindowDeviceName: deviceName,
    });
  }

  changerOrganization = async (org) => {
    this.props.history.push("/dashboard/create");
    this.props.getCurrentUser(this.props?.userReducer?.user?.email);
    this.props.setCurrentOrganization(org);
    const { id, name, displayName, profilePic } = org;
    const orgDetails = {
      id,
      name,
      displayName,
      profilePic,
    };
    // await window.cookieStore.set({
    //   name: "org_id",
    //   value: orgDetails.id,
    //   sameSite: window.location.hostname.startsWith("localhost")
    //     ? "strict"
    //     : "none",
    //   domain: window.location.hostname.startsWith("localhost")
    //     ? undefined
    //     : "supervity.ai",
    // });
    //document.cookie = `org_id=${orgDetails.id};`;
    setCookie("org_id", orgDetails?.id);
    this.props.changeActiveTab("Create");
    this.props.setGroupPlan();
  };

  handleSidebarClose = () => {
    // Select the child elements that contain the classes you want to hide
    const childElements = document.querySelectorAll(
      ".fixed-bar, .sidebar-global"
    );

    // Remove the 'active' class from each child element
    childElements.forEach((element) => {
      element.classList.remove("active");
    });
  };

  render() {
    const { organizationList, currentOrganization } =
      this.props.organizationReducer;

    var currentUser = this.props?.userReducer?.user?.email || null;
    var currentActiveTab = this.props?.skillReducer?.isActive || "";
    var currentMainUser = this.props?.organizationReducer?.currentOrgUser;
    const path = this.props.history.location.pathname;

    return (
      <div
        className={
          this.props?.appReducer?.minMode
            ? "task-list sidebar-global active"
            : "task-list sidebar-global"
        }
        style={{
          display:
            currentActiveTab === "Team" || currentActiveTab === "Settings"
              ? "none"
              : "",
        }}
      >
        <button
          className="close close-btn-sidebar"
          onClick={this.handleSidebarClose}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-x-circle"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
        </button>
        <div
          className="flex-title"
          onClick={() => {
            this.props.history.push("/dashboard/create");
          }}
        >
          <img src={techforceLogo} className="logo-sidebar" />
          {this.props?.appReducer?.minMode ? (
            <div
              className={
                this.props?.appReducer?.minMode ? "mb-close" : "mb-close"
              }
              onClick={() => {
                this.props.changeMode(false);
              }}
            ></div>
          ) : null}
        </div>

        <div class="dropdown team-admin">
          <button
            class="btn btn-default dropdown-toggle"
            type="button"
            data-toggle="dropdown"
          >
            <div className="team-name">
              <div className="team-setting-icon">
                <img
                  src={settingIcon}
                  onClick={(e) => {
                    if (this.props.organizationReducer.currentOrganization.id) {
                      this.props.changeActiveTab("Settings");
                      this.props.history.push({
                        pathname: `/settings/teams/${this.props.organizationReducer.currentOrganization.id}/people`,
                      });
                      e.stopPropagation();
                    }
                  }}
                  alt=""
                  data-tip="Team Settings"
                />
                <ReactTooltip place="top" type="dark" effect="solid" />
              </div>
              {organizationList?.map((org, index) => {
                if (!org.disabled) {
                  if (org.name === currentOrganization?.name) {
                    this.props.setCurrentOrganization("");
                    return "";
                  }
                  // else {
                  //   return currentOrganization?.name;
                  // }
                }
              })}
              {this.state.isLoading ? (
                "Loading..."
              ) : (
                <p>
                  {currentOrganization?.displayName
                    ? currentOrganization?.displayName + " " + "Team"
                    : currentOrganization?.name + " " + "Team"}
                </p>
              )}
            </div>
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu">
            {organizationList?.map((org, index) => {
              if (org?.disabled) {
                return (
                  <li
                    style={{
                      cursor: "pointer",
                      textTransform: "capitalize",
                      // pointerEvents: !org.disabled && "none",
                    }}
                    onClick={() => this.changerOrganization(org)}
                  >
                    <p
                      className="team-drop-name"
                      title={org?.displayName ? org.displayName : org?.name}
                    >
                      {org?.displayName ? org.displayName : org?.name}
                    </p>
                    {org?.isAdmin ? (
                      <span
                        onClick={(e) => {
                          if (
                            this.props.organizationReducer?.currentOrganization
                              ?.id
                          ) {
                            this.props.changeActiveTab("Settings");
                            this.props.history.push({
                              pathname: `/settings/teams/${org.id}/people`,
                            });
                            e.stopPropagation();
                          }
                        }}
                        className="edit-name"
                      >
                        <img src={editIcon} />
                      </span>
                    ) : null}
                  </li>
                );
              }
            })}
          </ul>
        </div>

        <div className="create">
          <button
            // className={
            //   this.props?.appReducer?.minMode
            //     ? "btn btn-primary"
            //     : "btn btn-primary"
            // }
            className="btn btn-primary"
            onClick={() => {
              this.props.changeActiveTab("Create");
              this.props.history.push("/dashboard/create");
              this.props.changeMode(false);
            }}
          >
            <span className="plus-white">+</span> Create AI Agent
          </button>
        </div>

        <ul className="list-group menu-scroll scrollable">
          {/* Accordion Starts */}
          <div className="panel-group panel-menu" id="accordion">
            <div className="panel panel-default">
              <div className="panel-heading">
                <h4 className="panel-title">
                  <a
                    className={`list-group-item flex-list-drop ${
                      currentActiveTab === "Published" ||
                      currentActiveTab === "Draft"
                        ? "active"
                        : ""
                    }`}
                    data-toggle="collapse"
                    data-parent="#accordion"
                    href="#collapse1"
                  >
                    <div className="left-list-menu">
                      <img src={mySkills} /> <span>AI Agents</span>
                    </div>{" "}
                    <img className="drop-icon" src={dropIcon} />
                  </a>
                </h4>
              </div>
              <div id="collapse1" className="panel-collapse collapse">
                <div className="panel-body drop-skills">
                  <ul className="list-group ">
                    <li
                      className={
                        this.props?.appReducer?.minMode
                          ? "list-group-item "
                          : `list-group-item ${
                              currentActiveTab === "Skills" ? "active" : ""
                            }`
                      }
                      onClick={() => {
                        this.props.changeActiveTab("Skills");

                        this.props.history.push("/dashboard/skills/draft");
                        this.props.changeMode(false);
                      }}
                    >
                      Agents
                    </li>

                    {/* <li
                      className={
                        this.props?.appReducer?.minMode
                          ? "list-group-item "
                          : `list-group-item ${
                              currentActiveTab === "Agents" ? "active" : ""
                            }`
                      }
                      onClick={() => {
                        this.props.changeActiveTab("Agents");

                        this.props.history.push(
                          "/dashboard/skills/viewAutomationV2"
                        );
                        this.props.changeMode(false);
                      }}
                    >
                      Agent Workflows
                    </li> */}
                    {/* <li
                      className={
                        this.props?.appReducer?.minMode
                          ? "list-group-item "
                          : `list-group-item ${
                              currentActiveTab === "Skill Sets" ? "active" : ""
                            }`
                      }
                      onClick={() => {
                        this.props.changeActiveTab("Skill Sets");

                        this.props.history.push("/dashboard/skills/skillSets");
                        this.props.changeMode(false);
                      }}
                    >
                      Skill Sets
                    </li> */}

                    {currentMainUser?.role_id == 2 ? (
                      <li
                        className={`${
                          this.props?.appReducer?.minMode
                            ? "list-group-item "
                            : `list-group-item ${
                                currentActiveTab === "Analytics" ? "active" : ""
                              }`
                        }`}
                        onClick={() => {
                          this.props.changeActiveTab("Analytics");
                          this.props.history.push(
                            `/dashboard/skills/analytics/${currentMainUser?.organization_id}`
                          );
                          this.props.changeMode(false);
                        }}
                      >
                        <span>Analytics</span>
                      </li>
                    ) : null}
                    <li
                      className={
                        this.props?.appReducer?.minMode
                          ? "list-group-item "
                          : `list-group-item ${
                              currentActiveTab === "schedules" ? "active" : ""
                            }`
                      }
                      onClick={() => {
                        this.props.changeActiveTab("schedules");

                        this.props.history.push("/dashboard/schedule");
                        this.props.changeMode(false);
                      }}
                    >
                      Schedules
                    </li>
                    <li
                      className={
                        this.props?.appReducer?.minMode
                          ? "list-group-item "
                          : `list-group-item ${
                              currentActiveTab === "knowledge" ? "active" : ""
                            }`
                      }
                      onClick={() => {
                        this.props.changeActiveTab("knowledge");

                        this.props.history.push(
                          "/dashboard/skills/collections"
                        );
                        this.props.changeMode(false);
                      }}
                    >
                      <span>AI Knowledge</span>
                    </li>

                    {/* <li
                      className={`list-group-item flex-list-drop ${currentActiveTab === "Snippet Code" ? "active" : ""}`}
                      onClick={() => {
                        this.props.changeActiveTab("Snippet Code");
                        this.props.history.push(
                          "/dashboard/skills/snippetCode"
                        );
                      }}
                    >
                      <div className="left-list-menu">
                        <span>Skill Snippet</span>
                      </div>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>

            {/* MY KNOWLEDGE */}

            {/* <div className="panel panel-default">
              <div className="panel-heading">
                <h4 className="panel-title">
                  <a
                    className={
                      this.props?.appReducer?.minMode
                        ? "list-group-item flex-list-drop"
                        : `list-group-item flex-list-drop ${
                            currentActiveTab === "Collections" ? "active" : ""
                          }`
                    }
                    onClick={() => {
                      this.props.changeActiveTab("Collections");

                      this.props.history.push("/dashboard/skills/collections");
                      this.props.changeMode(false);
                    }}
                  >
                    <div
                      className="left-list-menu"
                      onClick={() => this.props.changeMode(false)}
                    >
                      <img src={myKnowledgeIcon} alt="" />{" "}
                      <span>AI Knowledge</span>
                    </div>{" "}
                    <img className="drop-icon" src={dropIcon} alt="" />
                  </a>
                </h4>
              </div>
            </div> */}

            {/* My tasks */}

            <div className="panel panel-default">
              <div className="panel-heading">
                <h4 className="panel-title">
                  <a
                    className={
                      this.props?.appReducer?.minMode
                        ? "list-group-item flex-list-drop"
                        : `list-group-item flex-list-drop ${
                            currentActiveTab === "My Tasks" ? "active" : ""
                          }`
                    }
                    onClick={() => {
                      this.props.changeActiveTab("My Tasks");

                      this.props.history.push("/dashboard/approvals");
                    }}
                  >
                    <div
                      className="left-list-menu"
                      onClick={() => this.props.changeMode(false)}
                    >
                      <img src={mytaskIcon} alt="" /> <span>My Tasks</span>
                    </div>
                  </a>
                </h4>
              </div>
            </div>

            <div className="panel panel-default">
              <div className="panel-heading">
                <h4 className="panel-title">
                  <a
                    className={
                      this.props?.appReducer?.minMode
                        ? "list-group-item flex-list-drop"
                        : `list-group-item flex-list-drop ${
                            currentActiveTab === "Super Skills" ? "active" : ""
                          }`
                    }
                    onClick={() => {
                      this.props.changeActiveTab("Super Skills");

                      this.props.history.push("/dashboard/skill-store/agent-hub");
                      this.props.changeMode(false);
                    }}
                  >
                    <div
                      className="left-list-menu"
                      onClick={() => this.props.changeMode(false)}
                    >
                      <img src={superSkills} alt="" />{" "}
                      <span> AI Agent Hub</span>
                    </div>{" "}
                    {/* <img className="drop-icon" src={dropIcon} alt="" /> */}
                  </a>
                </h4>
              </div>
              {/* <div className="panel-heading">
                <h4 className="panel-title">
                  <a
                    className={
                      this.props?.appReducer?.minMode
                        ? "list-group-item flex-list-drop"
                        : `list-group-item flex-list-drop ${
                            currentActiveTab === "My Skills Home" ? "active" : ""
                          }`
                    }
                    onClick={() => {
                      this.props.changeActiveTab("My Skills Home");
                      this.props.history.push("/dashboard/skills/home");
                      this.props.changeMode(false);
                    }}
                  >
                    <div
                      className="left-list-menu"
                      onClick={() => this.props.changeMode(false)}
                    >
                      <img src={superSkills} alt="" />{" "}
                      <span> My Skills Home</span>
                    </div>{" "}
                  </a
                </h4>
              </div> */}
              <div id="collapse2" className="panel-collapse collapse">
                <div className="panel-body drop-skills">
                  <ul className="list-group">
                    <li
                      className={`list-group-item ${
                        currentActiveTab === "Automation" ? "active" : ""
                      }`}
                      onClick={() => {
                        this.props.changeActiveTab("AI Agent Hub");

                        this.props.history.push("/dashboard/skill-store/category/all");
                      }}
                    >
                      AI Agent Hub{" "}
                    </li>
                    {/* <li
                      className={`list-group-item ${
                        currentActiveTab === "Helper" ? "active" : ""
                      }`}
                      onClick={() => {
                        this.props.changeActiveTab("Helper");
                        this.props.history.push(
                          "/dashboard/skill-store/helper-skills/all"
                        );
                      }}
                    >
                      In-App Walkthroughs
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>

            {/* <div className="panel panel-default">
              <div className="panel-heading">
                <h4
                  className="panel-title"
                  onClick={() => {
                    this.props.changeActiveTab("schedule");
                    this.props.history.push("/dashboard/schedule");
                  }}
                >
                  <a
                    className={`list-group-item flex-list-drop ${
                      currentActiveTab === "schedule" ? "active" : ""
                    }`}
                  >
                    <div className="left-list-menu">
                      <img src={scheduleIcon} /> <span>Schedules</span>
                    </div>{" "}
                  </a>
                </h4>
              </div>
            </div> */}
          </div>
          {/* Accordion Ends */}
          {/* My Task Admin  */}
          {/* {currentUser === process.env.REACT_APP_ADMIN1 ||
          currentUser === process.env.REACT_APP_ADMIN2 ||
          currentUser === process.env.REACT_APP_ADMIN3 ||
          currentUser === process.env.REACT_APP_ADMIN4 ? (
            <li
              className={`list-group-item ${
                currentActiveTab === "Platforms" ? "active" : ""
              }`}
              onClick={() => {
                this.props.changeActiveTab("Platforms");
                this.props.history.push("/dashboard/platforms");
              }}
            >
              <img src={platformIcon} />
              <span>Platform</span>
            </li>
          ) : null} */}

          {currentUser === process.env.REACT_APP_ADMIN1 ||
          currentUser === process.env.REACT_APP_ADMIN2 ||
          currentUser === process.env.REACT_APP_ADMIN3 ||
          currentUser === process.env.REACT_APP_ADMIN4 ? (
            <li
              className={`list-group-item ${
                currentActiveTab === "AdminTask" ? "active" : ""
              }`}
              onClick={() => {
                this.props.changeActiveTab("AdminTask");
                this.props.history.push("/dashboard/tasks/approveWalkThrough");
                this.props.changeMode(false);
              }}
            >
              <img src={myTask} />
              <span>Admin Tasks</span>
            </li>
          ) : null}

          {/* {currentOrganization.isAdmin ? (
            <li
              className={`list-group-item ${
                currentActiveTab === "analytics" ? "active" : ""
              }`}
              onClick={() => {
                this.props.changeActiveTab("analytics");
                this.props.history.push(
                  "/dashboard/analytics/" + currentOrganization.id
                );
              }}
            >
              <img src={analyticsIcon} />
              <span>Analytics</span>
            </li>
          ) : null} */}

          {/* {currentOrganization?.isAdmin ? (
            <li
              className={
                this.props?.appReducer?.minMode
                  ? "list-group-item "
                  : `list-group-item ${
                      currentActiveTab === "template" ? "active" : ""
                    }`
              }
              onClick={() => {
                this.props.changeActiveTab("template");
                this.props.history.push("/dashboard/createYourTemplate");
                this.props.changeMode(false);
              }}
            >
              <img src={createTemplateIcon} />
              <span>Create Template</span>
            </li>
          ) : null} */}
        </ul>
        <div
          className={
            this.props?.appReducer?.minMode
              ? "footer-sidebar"
              : "footer-sidebar"
          }
          onClick={() => this.props.changeMode(false)}
        >
          {/* <button className="outline-new" data-toggle="modal" data-target="#myModal">+ Create a new skill</button> */}
          <div className="get-super-block">
            {this.state.showUpdateModal ? (
              <span className="label label-primary label-version">
                New Version Available {this.state.current_version}
              </span>
            ) : (
              ""
            )}

            {/* <img src={getSuperImg} /> */}
            <div className="super-ext-block">
              <div className="sp-ext-content">
                <h3>To create and use a 'Agent'</h3>
                <p>Get your super assitant app now</p>
                <span>Download for : </span>
              </div>
              <ul className="ext-icons">
                <ReactTooltip place="top" type="dark" effect="solid" />

                <li data-tip="For Web">
                  <img
                    src={webIcon}
                    onClick={() => {
                      this.props.changeActiveTab("connectWeb");
                      this.setState({
                        connectDevice: !this.state.connectDevice,
                      });
                    }}
                  />
                </li>
                <li data-tip="For Windows">
                  <img
                    src={windowsIcon}
                    onClick={() => {
                      this.props.changeActiveTab("connectWindow");
                      this.setState({
                        connectDevice: !this.state.connectDevice,
                      });
                    }}
                  />
                </li>
              </ul>
              <img src={extIcon} className="ext-icon" />
              <img src={extLayer} className="ext-layer" />
            </div>
          </div>
        </div>

        {/* GET SUPER APP */}

        {this.state.connectDevice && (
          <ConnectDevice
            stepOneToggle={(status) => {
              this.stepOneToggle(status);
            }}
            connectDeviceToggle={(status) => {
              this.connectDeviceToggle(status);
            }}
            stepTwoToggle={(status) => {
              this.stepTwoToggle(status);
            }}
            connectDevice={this.state.connectDevice}
            superWindowDeviceName={this.state.superWindowDeviceName}
            stepThreeToggle={(status) => {
              this.stepThreeToggle(status);
            }}
            stepThree={this.state.stepThree}
            stepFourToggle={(status) => {
              this.stepFourToggle(status);
            }}
            stepFour={this.state.stepFour}
          />
        )}
        {this.state.stepOne && (
          <StepOne
            stepOneToggle={(status) => {
              this.stepOneToggle(status);
            }}
            stepTwoToggle={(status) => {
              this.stepTwoToggle(status);
            }}
            stepOne={this.state.stepOne}
          />
        )}
        {this.state.stepTwo && (
          <StepTwo
            stepTwoToggle={(status) => {
              this.stepTwoToggle(status);
            }}
            stepThreeToggle={(status) => {
              this.stepThreeToggle(status);
            }}
            stepFourToggle={(status) => {
              this.stepFourToggle(status);
            }}
            stepTwo={this.state.stepTwo}
          />
        )}
        {this.state.stepThree && (
          <StepThree
            stepThreeToggle={(status) => {
              this.stepThreeToggle(status);
            }}
            stepFourToggle={(status) => {
              this.stepFourToggle(status);
            }}
            stepThree={this.state.stepThree}
          />
        )}
        {this.state.stepFour && (
          <StepFour
            stepFourToggle={(status) => {
              this.stepFourToggle(status);
            }}
            stepFour={this.state.stepFour}
            superWindowDeviceNameToggle={(deviceName) => {
              this.superWindowDeviceNameToggle(deviceName);
            }}
            connectDeviceToggle={(status) => {
              this.connectDeviceToggle(status);
            }}
          />
        )}
        {this.state.stepFive && <StepFive stepFive={this.state.stepFive} />}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  organizationReducer: state.organizationReducer,
  userReducer: state.userReducer,
  notifications: state.appReducer.notifications,
  notified: state.appReducer.notified,
  skillReducer: state.skillReducer,
  appReducer: state.appReducer,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    changeActiveTab,
    getOrganizations,
    setCurrentOrganization,
    changeMode,
    getCurrentUser,
    setGroupPlan,
  })
)(SideBar);
